import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import reportWebVitals from "./reportWebVitals";
import SimpleReactLightbox from "simple-react-lightbox";
import ThemeContext from "./context/ThemeContext";

import { HashRouter as Router, Route, Switch, withRouter, Link, Redirect } from 'react-router-dom';

ReactDOM.render(
    < Provider store={store} >
        <SimpleReactLightbox>
            <Router>
                <ThemeContext>
                    <App />
                </ThemeContext>
            </Router>
        </SimpleReactLightbox>
    </Provider >,
    document.getElementById("root")
);
reportWebVitals();
